import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'

import ImgBox from '../../components/Gamification/ImgBox'
import CreatNft from '../../components/Gamification/CreatNft'
import {Info} from '../../components/Gamification/InfoBox'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
    justify-content: center;
  `};
`

export default function Soccer () {
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/soccernft.gif'}/>
        <RowColumn>
          <CreatNft type={NFTTYPE.SOCCER} />
          <Info>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>Details of Soccer NFTs:</Text>
            <Text fontSize={14} marginTop={20}>1. Each Soccer NFT correspnds to one of the Limited Edition of Bakery Exclusive Soccer Balls in the real world.  Soccer NFTs can be redeemed to real-world soccer balls later. </Text>
            <Text fontSize={14} marginTop={20}>2. Synthesizing a Soccer NFT will consume a Soccer Token.  The Soccer Token consumed will be burned, so Soccer NFTs can NOT be transformed back to Soccer Tokens. </Text>
            <Text fontSize={14} marginTop={20}>3. Soccer NFTs will be traded on the NFT Marketplace.  However, the liquidity of the NFT Marketplace is not as good as the AMM Dex, so please consider carefully before synthesizing the Soccer NFTs.</Text>
            <Text fontSize={14} marginTop={20}>4. In addition, Soccer NFT can be staked to earn BAKE with a good APY.</Text>
          </Info>
        </RowColumn>
      </Main>
    </SoccerMain>
  )
}